<div class="iot-page">

    <!-- ── Page header ───────────────────────────────── -->
    <div class="iot-header">
        <div class="iot-header-left">
            <h2 class="iot-title">IOT</h2>
        </div>
        <div class="iot-header-actions">
            <button class="iot-btn" type="button" disabled>
                <i class="fa-solid fa-arrow-up-from-bracket"></i> Export
            </button>
            @if (activeTab === 1) {
            <button class="iot-btn iot-btn--primary" type="button" (click)="openAddIot()">
                <i class="fa-solid fa-plus"></i> Add IOT
            </button>
            }
        </div>
    </div>

    <!-- ── Tabs ──────────────────────────────────────── -->
    <div class="iot-tabs">
        <button class="iot-tab" [class.iot-tab--active]="activeTab === 0"
            (click)="switchTab(0)" type="button">IOT data log</button>
        <button class="iot-tab" [class.iot-tab--active]="activeTab === 1"
            (click)="switchTab(1)" type="button">Manage IOT</button>
    </div>

    <!-- ── Tab content ───────────────────────────────── -->
    <div class="iot-card">
        <div [hidden]="activeTab !== 0">
            <app-iot-data-log-list />
        </div>
        <div [hidden]="activeTab !== 1">
            <app-manag-iot-list #manageIot />
        </div>
    </div>

</div>
